import Vue from "vue";

//libs
import PortalVue from "portal-vue";
import { createDateFilter } from "vue-date-fns";
import locale from "date-fns/locale/en-AU";

Vue.use(PortalVue);
Vue.filter("dateFilter", createDateFilter("d MMMM yyyy", { locale }));

//components
import DesktopNavigation from "./components/DesktopNavigation.vue";
import NavOverlay from "./components/NavOverlay.vue";
import CourseLocations from "./components/CourseLocations";
import FaqContent from "./components/FaqContent";
import ToggleContent from "./components/ToggleContent";
import Modal from "./components/Modal";
import HeaderSearchInput from "./components/HeaderSearchInput";
import ClipboardLink from "./components/ClipboardLink";
import StoryTeasersSlider from "./components/StoryTeasersSlider";
import VideoOverlay from "./components/VideoOverlay";
import VideoIframe from "./components/VideoIframe";
import Overview from "./components/Overview";
import CourseOverview from "./components/CourseOverview";
import VacancyOverview from "./components/VacancyOverview";
import VacancyIntro from "./components/VacancyIntro";
import TeamMarquee from "./components/TeamMarquee";

new Vue({
	el: "#app",
	components: {
		DesktopNavigation,
		NavOverlay,
		CourseLocations,
		FaqContent,
		ToggleContent,
		Modal,
		HeaderSearchInput,
		ClipboardLink,
		StoryTeasersSlider,
		VideoOverlay,
		VideoIframe,
		Overview,
		CourseOverview,
		VacancyOverview,
		VacancyIntro,
		TeamMarquee,
	},
});

const popup_close = document.getElementById("popup__close");
if (popup_close) {
	popup_close.addEventListener("click", function (e) {
		const form = document.getElementById("no-results-form");
		if (!form) {
			console.log("No form found");
			return;
		}
		if (form.style.display === "none") {
			form.style.display = "block";
			form.style.visibility = "visible";
		} else {
			form.style.display = "none";
			form.style.visibility = "hidden";
		}
	});
}


const popup__close_job_alert = document.getElementById("popup__close_job_alert");
if (popup__close_job_alert) {
	popup__close_job_alert.addEventListener("click", function (e) {
		const form = document.getElementById("job-alert-form");
		if (!form) {
			console.log("No form found");
			return;
		}
		if (form.style.display === "none") {
			form.style.display = "block";
			form.style.visibility = "visible";
		} else {
			form.style.display = "none";
			form.style.visibility = "hidden";
		}
	});
}


const popup__close_button = document.getElementById("popup__close_button");
if (popup__close_job_alert) {
	popup__close_button.addEventListener("click", function (e) {
		const form = document.getElementById("job-alert-form");
		if (!form) {
			console.log("No form found");
			return;
		}
		if (form.style.display === "none") {
			form.style.display = "block";
			form.style.visibility = "visible";
		} else {
			form.style.display = "none";
			form.style.visibility = "hidden";
		}
	});
}

